import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';

class conciergeStore {

    // Main Properties

    @observable conciergeItems = [];
    @observable conciergePendingOrder = undefined;
    @observable conciergeRemark = '';

    // Concierge Confirm

    @observable conciergeTimeSelected = 'now';
    @observable conciergeTimeDeliver = '';
    @observable conciergeTimeDeliverDate = '';

    // Initialization

    @action initGetConcierges() {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.Concierges.apiGetConcierges(languageCode).then((conciergeResponses) => {
            if (conciergeResponses) {
                that.conciergeItems = conciergeResponses.items;
            } else {
                that.conciergeItems = [];
            }
        });
    }

    @action refreshConcierges() {
        const that = this;
        that.conciergeItems = [];

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.Concierges.apiGetConcierges(languageCode).then((conciergeResponses) => {
            if (conciergeResponses) {
                that.conciergeItems = conciergeResponses.items;
            }
        });
    }

    @action initConciergeConfirm() {
        this.conciergeRemark = '';
        this.conciergeTimeSelected = 'now';
        this.conciergeTimeDeliver = '';

        this.conciergePendingOrder = this.conciergeItems.find(conciergeItem => conciergeItem.isSelected === true);
        return this.conciergePendingOrder;
    }

    // GET Properties

    @action getConciergePendingOrder() {
        return this.conciergeItems.find(conciergeItem => conciergeItem.isSelected === true);;
    }

    // Set Properties

    @action setConciergeIsSelected(taskId, isSelected) {
        this.conciergeItems.map(conciergeItem => {
            return conciergeItem.isSelected = false;
        });

        const conciergeItem = this.conciergeItems.find(x => x.taskId === taskId);
        conciergeItem.isSelected = isSelected;
    }

    @action setConciergeRemark(value) {
        this.conciergeRemark = value;
    }

    @action setConciergeTimeSelected(value) {
        this.conciergeTimeSelected = value;
        this.conciergeTimeDeliver = '';
    }

    @action setConciergeTimeDeliver(value) {
        this.conciergeTimeDeliver = value;
        this.conciergeTimeSelected = '';
    }

    @action setConciergeTimeDeliverDate(value) {
        this.conciergeTimeDeliverDate = value;
    }

    // RESET Properties

    @action resetConcierges() {
        this.conciergeItems = [];
    }
}

export default new conciergeStore()